import { useMutation } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { initiateAgreementSignature } from './listingRequestEndpoints'
import { parseSigningInitiation } from './listingRequestParser'
import type { AgreementSignatureTarget } from '../types/listingRequestTypes'

// Starts a UAE Pass signing session for one signatory. No cache change — the
// caller redirects the browser to the returned `signUrl`; the refreshed
// agreement is picked up on return via the complete mutation.
export function useInitiateAgreementSignatureMutation(id: MaybeRefOrGetter<string>) {
  return useMutation({
    mutationFn: (target: AgreementSignatureTarget) =>
      initiateAgreementSignature(toValue(id), target.agreementId, target.signatoryId).then(
        parseSigningInitiation,
      ),
  })
}
